import axios from 'axios';
import qs from 'qs';
import networkConf from './Config/network';
import Store from './Store';
import getCountryParam from '../Utils/getCountryParam';

const CancelToken = axios.CancelToken;
let source = CancelToken.source();

/**
 * axios instance to handle API requests
 */
const ax = axios.create({
  baseURL: networkConf.baseURL,
  timeout: networkConf.timeout,
  cancelToken: source.token,
  params: {
    _country: getCountryParam(),
  },

  paramsSerializer: function (params) {
    return qs.stringify(params, { arrayFormat: 'brackets' });
  },
});

const setLanguageAndCountryParams = (config) => {
  const { selectedCountry, selectedLanguage } = Store.getState().Country;
  config.params._country = selectedCountry;
  if (selectedLanguage) {
    config.params._language = selectedLanguage;
  }
};

export function createRequest() {
  let cancelSource = CancelToken.source();
  return {
    request: (config) => {
      config = typeof config === 'string' ? { url: config } : config;
      const mixedConfig = {
        ...ax.defaults,
        ...config,
        cancelToken: cancelSource.token,
      };
      setLanguageAndCountryParams(mixedConfig);
      return axios.request(mixedConfig);
    },
    cancel: () => {
      cancelSource.cancel();
      cancelSource = CancelToken.source();
    },
  };
}
